import { COMMUNICATION_LANGUAGES } from '../constants/constants';

const REGISTER_URI_STORAGE_KEY = 'auth_register_uri';

const ROLE_BY_LOWER = {
  private: 'Private',
  marina: 'Marina',
  guest: 'Guest',
};

function readSessionStorage() {
  if (typeof window === 'undefined') {
    return null;
  }
  try {
    return window.sessionStorage;
  } catch (error) {
    return null;
  }
}

/**
 * Legacy QR / register links use one ampersand-separated path segment:
 * firstname & lastname & email & mobilenumber & role & language & referral & club & marina
 * Example: &&&&Private&DE&&YCD&&
 */
export function parseRegisterUriArgs(rawArgs) {
  if (!rawArgs) {
    return null;
  }

  let decoded = String(rawArgs);
  try {
    decoded = decodeURIComponent(decoded);
  } catch (error) {
    decoded = String(rawArgs);
  }
  decoded = decoded.replace(/\/+$/, '');
  if (!decoded.includes('&')) {
    return null;
  }

  const args = decoded.split('&');
  const language = (args[5] || '').trim().toUpperCase();
  const roleRaw = (args[4] || '').trim();
  const role = ROLE_BY_LOWER[roleRaw.toLowerCase()] || roleRaw;

  const parsed = {
    firstName: (args[0] || '').trim(),
    lastName: (args[1] || '').trim(),
    email: (args[2] || '').trim(),
    phone: (args[3] || '').trim(),
    role,
    language: COMMUNICATION_LANGUAGES.includes(language) ? language : '',
    referralAccount: (args[6] || '').trim(),
    club: (args[7] || '').trim(),
    marina: (args[8] || '').trim(),
  };

  const hasValue = Object.values(parsed).some((value) => value);
  return hasValue ? parsed : null;
}

export function storeRegisterUri(registerUri) {
  const storage = readSessionStorage();
  if (!storage || !registerUri) {
    return;
  }
  try {
    storage.setItem(REGISTER_URI_STORAGE_KEY, JSON.stringify(registerUri));
  } catch (error) {
    // ignore write failures
  }
}

export function readRegisterUri() {
  const storage = readSessionStorage();
  if (!storage) {
    return null;
  }
  try {
    const raw = storage.getItem(REGISTER_URI_STORAGE_KEY);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (error) {
    return null;
  }
}

export function clearRegisterUri() {
  const storage = readSessionStorage();
  if (!storage) {
    return;
  }
  try {
    storage.removeItem(REGISTER_URI_STORAGE_KEY);
  } catch (error) {
    // ignore removal failures
  }
}

export function registerUriFromPath(pathname) {
  const path = pathname || '';
  const prefix = '/register/';
  if (!path.startsWith(prefix)) {
    return null;
  }
  const rawArgs = path.slice(prefix.length).split('/')[0];
  return parseRegisterUriArgs(rawArgs);
}

export function resolveRegisterUri(location) {
  if (location?.state?.registerUri) {
    return location.state.registerUri;
  }
  const path = location?.pathname || '';
  if (path !== '/auth' && path !== '/auth/') {
    return null;
  }
  return readRegisterUri();
}

export function registerUriRequestFields(registerUri) {
  if (!registerUri) {
    return {};
  }
  const fields = {};
  if (registerUri.referralAccount) {
    fields.referralAccount = registerUri.referralAccount;
  }
  if (registerUri.club) {
    fields.club = registerUri.club;
  }
  if (registerUri.marina) {
    fields.marina = registerUri.marina;
  }
  return fields;
}
